import React, {useCallback, useEffect, useRef, useState} from 'react';
import { StyledDropDownTrigger, StyledMenuItem, StyledMenuList, StyledMenuWrapper } from './styles';
import { IDropdownProps } from './types';
import { TextButton } from '../globalStyles';
import ClickAway from '../clickAway';
import ReactDOM from "react-dom";

const DetachedDropdownMenu: React.FC<IDropdownProps> = props => {
    const { trigger, items = [], children, isOpen, onChange, defaultOpen, direction = 'down' } = props;
    const [stateIsOpen, setIsOpen] = useState<boolean>(defaultOpen || false);
    const [menuPosition, setMenuPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });
    const triggerRef = useRef<HTMLDivElement>(null);
    const menuRef = useRef<HTMLDivElement>(null);


    useEffect(() => {
        if (stateIsOpen && triggerRef.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            let left = rect.left + window.scrollX;
            let top = rect.bottom + window.scrollY;

            // Даем время порталу отрендериться
            setTimeout(() => {
                if (menuRef.current) {
                    const menuRect = menuRef.current.getBoundingClientRect();
                    const overflowRight = menuRect.right - window.innerWidth;
                    if (overflowRight > 0) {
                        left = Math.max(window.scrollX, left - overflowRight - 30);
                        setMenuPosition({ top, left });
                    }
                }
            }, 0);

            setMenuPosition({ top, left });
        }
    }, [stateIsOpen]);

    useEffect(() => {
        if (typeof isOpen !== 'boolean') return;
        setIsOpen(isOpen);
    }, [isOpen]);

    const onChangeHandler = useCallback(() => {
        setIsOpen(!stateIsOpen);
        if (!onChange) return;
        onChange(!stateIsOpen);
    }, [onChange, stateIsOpen]);

    const menuList = <StyledMenuList
        ref={menuRef}
        isOpen={stateIsOpen}
        offset={10}
        direction={direction}
        style={{
            position: 'absolute',
            top: menuPosition.top,
            left: menuPosition.left,
            right: 'auto',
            bottom: 'auto',
            minWidth: triggerRef.current?.offsetWidth,
        }}
    >
        {!!items.length &&
            items.map(({ label, onClick, type }) => (
                <StyledMenuItem key={label} onClick={(event: React.MouseEvent) => { event.stopPropagation(); setIsOpen(false); if(onClick) onClick() }} type={type || 'button'}>
                    <TextButton>{label}</TextButton>
                </StyledMenuItem>
            ))}
        {!items.length && children}
    </StyledMenuList>;

    return (
        <StyledMenuWrapper>
            <ClickAway onClickAway={onChangeHandler} isOpen={stateIsOpen}>
                <StyledDropDownTrigger ref={triggerRef} onClick={(e: React.MouseEvent) => {
                    e.stopPropagation();
                    onChangeHandler();
                }}>{trigger}</StyledDropDownTrigger>
                {stateIsOpen && menuPosition.top > 0 && ReactDOM.createPortal(menuList, document.body)}
            </ClickAway>
        </StyledMenuWrapper>
    );
};

export default React.memo(DetachedDropdownMenu);
